var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8086 12.8633C13.9362 12.9909 14 13.1458 14 13.3281C14 13.5104 13.9362 13.6654 13.8086 13.793L13.043 14.5586C12.9154 14.6862 12.7604 14.75 12.5781 14.75C12.3958 14.75 12.2409 14.6862 12.1133 14.5586L9.37891 11.8242C9.2513 11.6966 9.1875 11.5417 9.1875 11.3594V10.9219C8.16667 11.724 7 12.125 5.6875 12.125C4.11979 12.125 2.77995 11.569 1.66797 10.457C0.55599 9.34505 0 8.00521 0 6.4375C0 4.86979 0.55599 3.52995 1.66797 2.41797C2.77995 1.30599 4.11979 0.75 5.6875 0.75C7.25521 0.75 8.59505 1.30599 9.70703 2.41797C10.819 3.52995 11.375 4.86979 11.375 6.4375C11.375 7.75 10.974 8.91667 10.1719 9.9375H10.6094C10.7917 9.9375 10.9466 10.0013 11.0742 10.1289L13.8086 12.8633ZM3.19922 8.92578C3.89193 9.60026 4.72135 9.9375 5.6875 9.9375C6.65365 9.9375 7.47396 9.60026 8.14844 8.92578C8.84115 8.23307 9.1875 7.40365 9.1875 6.4375C9.1875 5.47135 8.84115 4.65104 8.14844 3.97656C7.47396 3.28385 6.65365 2.9375 5.6875 2.9375C4.72135 2.9375 3.89193 3.28385 3.19922 3.97656C2.52474 4.65104 2.1875 5.47135 2.1875 6.4375C2.1875 7.40365 2.52474 8.23307 3.19922 8.92578Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fb3dfd5d952f80b5705f85c7ef08effb.svg";
export { ForwardRef as ReactComponent };